import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as S from "../css/MenuComponent.styles";
import { isBlackUIViewState } from "../stores/isBlackUIViewState";
import { useRecoilState, useResetRecoilState } from "recoil";
import { loginState } from "../stores/loginState";
import { videoListState } from "../stores/vass/videoListState";
import { nowVassDetailState } from "../stores/vass/nowVassDetailState";
import { prevVassDetailState } from "../stores/vass/prevVassDetailState";
import { barcodeDataState } from "../stores/barcode/barcodeDataState";
import { editDataState } from "../stores/edit/editDataState";
import { trackingValueState } from "../stores/barcode/trackingValueState";
import { barcodeTrackingState } from "../stores/barcode/barcodeTrackingState";
import { selectBarcodeState } from "../stores/addbarcode/selectBarcodeState";
import { focusCCTVUrlState } from "../stores/vass/focusCCTVUrlState";
import { addBarcodeResultState } from "../stores/addbarcode/addBarcodeResultState";
import { barcodeAddState } from "../stores/addbarcode/barcodeAddState";
import { todayState } from "../stores/dashboard/todayState";
import { calendarDataState } from "../stores/calendar/calendarDataState";
import useGetLoginToken from "../api/useGetLoginToken";

function MenuComponent(props) {
  // NOTE 상태 변수 선언
  const [login, setLogin] = useRecoilState(loginState); // 로그인 전역변수
  const [isBlackUI, setIsBlackUI] = useRecoilState(isBlackUIViewState); // 테마 다크모드 여부
  const location = useLocation(); // 현재 위치 함수
  const navigate = useNavigate(); // 위치 이동 함수

  const resetLogin = useResetRecoilState(loginState); // 로그인 정보 초기화
  const resetVideoList = useResetRecoilState(videoListState); // CCTV 동영상 리스트 초기화
  const resetNowVassDetail = useResetRecoilState(nowVassDetailState); // 현재 운송장 번호 초기화
  const resetPrevVassDetail = useResetRecoilState(prevVassDetailState); // 이전 운송장 번호 초기화
  const resetBarcodeData = useResetRecoilState(barcodeDataState); // 운송장 데이터 초기화
  const resetEditData = useResetRecoilState(editDataState); // 업무수정 데이터 초기화
  const resetTrackingValue = useResetRecoilState(trackingValueState); // 화물추적 운송장, 일자 정보 초기화
  const resetBarcodeTracking = useResetRecoilState(barcodeTrackingState); // 화물추적 데이터 초기화
  const resetSelectBarcode = useResetRecoilState(selectBarcodeState); //  정보 초기화
  const resetCCTVUrl = useResetRecoilState(focusCCTVUrlState); // CCTV 동영상 선택 정보 초기화
  const resetAddBarcode = useResetRecoilState(barcodeAddState); // 운송장 추가등록 점소정보 초기화
  const resetAddBarcodeResult = useResetRecoilState(addBarcodeResultState); // 운송장 등록 결과 데이터 초기화
  const resetToday = useResetRecoilState(todayState); // 오늘 결과 데이터 초기화
  const resetCalendarData = useResetRecoilState(calendarDataState); // 월별 데이터 초기화
  const resetIsBlack = useResetRecoilState(isBlackUIViewState); // 다크모드 초기화

  let passwordChangeWindow = null; // 비밀번호 변경 창 열림 여부

  // TODO 운송장 등록 API
  const { mutate: getLoginToken } = useGetLoginToken();

  // NOTE 로그아웃 버튼 클릭 시
  const onClickLogout = () => {
    if (login.isUserIdStored) {
      setLogin({ ...login, isLogin: false, branchName: "", localIP: "" });
    } else {
      resetLogin();
      resetVideoList();
      resetNowVassDetail();
      resetPrevVassDetail();
      resetBarcodeData();
      resetEditData();
      resetTrackingValue();
      resetBarcodeTracking();
      resetSelectBarcode();
      resetCCTVUrl();
      resetAddBarcode();
      resetAddBarcodeResult();
      resetToday();
      resetCalendarData();
      resetIsBlack();
    }

    navigate("/");
  };

  // NOTE 비밀번호 변경 버튼 클릭 시
  const handlePasswordChange = () => {
    // 창이 이미 열려 있고 닫히지 않았는지 확인
    if (passwordChangeWindow && !passwordChangeWindow.closed) {
      // 열린 창에 포커스를 맞춤
      passwordChangeWindow.focus();
      return;
    }

    // 새 창 열기
    passwordChangeWindow = window.open(
      "/ChangePassword",
      "_blank",
      "width=500,height=500,scrollbars=no,location=no",
    );

    // 새 창이 닫힐 때 메인 창을 새로고침
    passwordChangeWindow.onbeforeunload = () => {
      window.location.reload();
    };

    // 새 창의 스타일 설정
    passwordChangeWindow.onload = () => {
      passwordChangeWindow.document.body.style.overflow = "hidden";
    };
  };

  //
  const nvrRun = () => {
    window.onerror = function (message, source, lineno, colno, error) {
      console.error("Custom URL Scheme 호출 실패:", message);
      // 실패 처리 로직
    };

    navigate("/NvrRun");
    getLoginToken();
  };

  const company =
    login.company === "LOGEN"
      ? "로젠"
      : login.company === "LOTTE"
        ? "롯데"
        : login.company === "HANJIN"
          ? "한진"
          : "한덱스";

  // NOTE 로그인 여부에 따라 창 변경
  useEffect(() => {
    if (!login.isLogin) {
      navigate("/");
    }
  }, [login, navigate]);

  return (
    <S.BackGroundContainer>
      <S.MenuContainer>
        <S.HeaderContainer>
          <a href="https://www.jhcon.net/">
            <img
              src={require("../assets/images/logo.png")}
              alt=""
              style={{ maxWidth: "70px" }}
            />
          </a>
          <p>(주) 제이에이치씨</p>
        </S.HeaderContainer>
        <hr
          style={{
            border: `1px solid ${props.theme.black1}`,
            width: "80%",
            height: "1px",
            margin: "0",
          }}
        />
        <S.InfoContainer>
          <h4>
            {login.branchName}({login.branchCode}) {company}지점
          </h4>
        </S.InfoContainer>
        <hr
          style={{
            border: `1px solid ${props.theme.black1}`,
            width: "80%",
            height: "1px",
            margin: "0",
          }}
        />
        <S.SelectContainer>
          <span
            onClick={() => navigate("/Dashboard")}
            style={{
              backgroundColor:
                location.pathname === "/Dashboard" ? props.theme.white4 : "",
            }}
          >
            <img
              src={require(`../assets/icons/dashboard${props.theme.icon}.png`)}
              alt=""
            />
            대시보드
          </span>

          <span
            onClick={() => navigate("/Barcode")}
            style={{
              backgroundColor:
                location.pathname === "/Barcode" ? props.theme.white4 : "",
            }}
          >
            <img
              src={require(`../assets/icons/barcode${props.theme.icon}.png`)}
              alt=""
            />
            운송장관리
          </span>
          {(login.company === "LOGEN" || login.company === "LOTTE") && (
            <>
              <span
                onClick={() => navigate("/AddBarcode")}
                style={{
                  backgroundColor:
                    location.pathname === "/AddBarcode"
                      ? props.theme.white4
                      : "",
                }}
              >
                <img
                  src={require(
                    `../assets/icons/addBarcode${props.theme.icon}.png`,
                  )}
                  alt=""
                />
                운송장추가등록
              </span>
              <span
                onClick={() => navigate("/Edit")}
                style={{
                  backgroundColor:
                    location.pathname === "/Edit" ? props.theme.white4 : "",
                }}
              >
                <img
                  src={require(`../assets/icons/edit${props.theme.icon}.png`)}
                  alt=""
                />
                업무수정관리
              </span>
            </>
          )}
          <span
            onClick={() => navigate("/Calendar")}
            style={{
              backgroundColor:
                location.pathname === "/Calendar" ? props.theme.white4 : "",
            }}
          >
            <img
              src={require(`../assets/icons/calendar${props.theme.icon}.png`)}
              alt=""
            />
            월별실적조회
          </span>
          {/* NOTE 테스트 메뉴는 URL 직접 접근만 허용 */}
          {login.camUsable === "2" && (
            <span
              onClick={() => navigate("/Vass")}
              style={{
                backgroundColor:
                  location.pathname === "/Vass" ? props.theme.white4 : "",
              }}
            >
              <img
                src={require(`../assets/icons/vass${props.theme.icon}.png`)}
                alt=""
              />
              운송장영상추적
            </span>
          )}
          {/* {login.camUsable === "2" && (
            <span
              style={{
                backgroundColor:
              }}
            >
              <img
                src={require(`../assets/icons/vass${props.theme.icon}.png`)}
                alt=""
              />
              운송장영상테스트
            </span>
          )} */}
          {/* {login.camUsable === "2" &&
            (
              <span
                onClick={() => navigate("/Nvr")}
                style={{
                  backgroundColor:
                    location.pathname === "/Nvr" ? props.theme.white4 : "",
                }}
              >
                <img
                  src={require(`../assets/icons/nvrweb${props.theme.icon}.png`)}
                  alt=""
                />
                NVR영상화물추적
              </span>

            )
          } */}
          {login.nvrUsable === "1" && (
            <span
              onClick={() => nvrRun()}
              style={{
                backgroundColor:
                  location.pathname === "/NvrRun" ? props.theme.white4 : "",
              }}
            >
              <img
                src={require(`../assets/icons/nvr${props.theme.icon}.png`)}
                alt=""
              />
              NVR프로그램실행
            </span>
          )}
        </S.SelectContainer>
        <label className="toggle">
          <span>화이트 / 다크모드</span>
          <input
            role="switch"
            type="checkbox"
            defaultChecked={isBlackUI}
            onClick={() => setIsBlackUI(!isBlackUI)}
          />
        </label>
        <S.FooterContainer>
          <S.ChangePasswordContainer>
            <span onClick={handlePasswordChange}>
              <img
                src={require(`../assets/icons/changePw${props.theme.icon}.png`)}
                alt=""
                style={{ width: "32px", height: "32px" }}
              />
              <p>비밀번호 변경</p>
            </span>
            <span onClick={onClickLogout}>
              <img
                src={require(`../assets/icons/signout${props.theme.icon}.png`)}
                alt=""
                style={{ width: "32px", height: "32px" }}
              />
              <p>로그아웃</p>
            </span>
          </S.ChangePasswordContainer>
        </S.FooterContainer>
      </S.MenuContainer>
    </S.BackGroundContainer>
  );
}
export default MenuComponent;
